import { useCallback } from "react";
import { useAppSelector } from "../store/storeTypes";
import { isBrowserSimulation } from "../features/menu/pages/Menu";

export const useCustomiseScrollHelpers = (refs, customiseBannerRef, customisePageRef, invalidSections) => {
    const { isTabletScreen } = useAppSelector(state => state.session);

    const handleRequiredScrolling = useCallback(
        (customisedObjId) => {
            const sections = Array.from(document.getElementsByClassName('customise-section'));
            const firstInvalidSectionNode = sections.filter(el => invalidSections.find(s => el.dataset.sectionErrorId === s) && el.dataset.sectionErrorId !== customisedObjId)[0];
            if (invalidSections.length && firstInvalidSectionNode) {
                setTimeout(() => scrollToInvalidSection(firstInvalidSectionNode), 200);
            }
        },
        [invalidSections],
    );

    const scrollToInvalidSection = useCallback(
        (invalidSection) => {
            const isSimulation = isBrowserSimulation();

            const offsetHeight =
                refs.current.navRef?.clientHeight +
                customiseBannerRef?.current?.clientHeight +
                (!isTabletScreen ? 40 : 0);

            const currentScrollY = isSimulation
                ? document?.documentElement.scrollTop
                : window?.scrollY;

            const scrollOptions = {
                top: currentScrollY + invalidSection.getBoundingClientRect().top - offsetHeight,
                behavior: 'smooth',
                block: 'center'
            };
            window?.scrollTo(scrollOptions);
        },
        [refs, customiseBannerRef, customisePageRef, isTabletScreen]
    )

    return {
        scrollToRequired: (customisedObjId) => handleRequiredScrolling(customisedObjId),
        scrollToInvalidSection: (invalidSection) => scrollToInvalidSection(invalidSection)
    };
};